import Loadable from "app/components/Loadable";
import { lazy } from "react";

const CompanyList = Loadable(lazy(() => import("./CompanyList")));
const CompanyForm = Loadable(lazy(() => import("./CompanyForm")));

const companyRoutes = [
  {
    path: "/Company/CompanyList",
    element: <CompanyList />,
  },
  {
    path: "/Company/CompanyForm",
    element: <CompanyForm />,
  },
  {
    path: "/Company/CompanyForm/:companyId",
    element: <CompanyForm />,
  },
];

export default companyRoutes;
